import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getSupportedCurrencies} from 'src/openapi/admin/apis/GetSupportedCurrenciesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectCurrencies} from './services/dictionary-slice';

export const useCurrencies = () => {
    const apiDispatch = useAppDispatch();
    const currencies = useSelector(selectCurrencies);

    const loadCurrencies = useCallback(() => {
        if (!currencies.length) {
            apiDispatch(getSupportedCurrencies());
        }
    }, [currencies.length, apiDispatch]);

    return {currencies, loadCurrencies};
};
